export default __webpack_public_path__ + "static/media/twitter.3ddf5b44.svg";